class Office {
    constructor() {
        this.filters = document.querySelectorAll('.js-office-select');

        if (this.filters.length) {
            this.filters.forEach((item) => {
                Office.bind(item);
            });
        }
    }

    static bind(item) {
        item.addEventListener('change', () => {
            Office.updateContainer(item);
        });
        Office.updateContainer(item);
    }

    static updateContainer(select) {
        const container = select.closest('.js-exhibitor-item');
        container.querySelectorAll('.js-order-item').forEach((item) => {
            item.classList.toggle('hidden', select.value && parseInt(select.value, 10) !== parseInt(item.dataset.office, 10));
        });
    }
}

export default Office;
